var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.40002 5.40005H21.6M8.40002 1.80005H15.6M9.60002 17.4V10.2M14.4 17.4V10.2M16.2 22.2H7.80002C6.47454 22.2 5.40002 21.1255 5.40002 19.8L4.85211 6.65001C4.8237 5.96826 5.36872 5.40005 6.05106 5.40005H17.949C18.6313 5.40005 19.1763 5.96826 19.1479 6.65001L18.6 19.8001C18.6 21.1255 17.5255 22.2 16.2 22.2Z",
    stroke: "#F41010",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trashIcon.e4d71a61e1c849d0d91f7a1920fd950c.svg";
export { ForwardRef as ReactComponent };